<template>
  <div class="site-page site-page--fluid nav-content-inset">
    <div class="site-page__inner">
      <div class="page-head">
        <h1 class="site-page__title">站内信</h1>
        <div class="page-head__actions">
          <el-radio-group v-model="readFilter" size="small" @change="onFilter">
            <el-radio-button :label="-1">全部</el-radio-button>
            <el-radio-button :label="0">未读</el-radio-button>
            <el-radio-button :label="1">已读</el-radio-button>
          </el-radio-group>
          <el-button type="primary" plain :disabled="!hasUnread" @click="markAllRead">全部标为已读</el-button>
        </div>
      </div>
      <p class="site-page__lead msg-hint">未读行加粗高亮；点一行即可标为已读。来源为中文分类。</p>
      <el-table
        :data="items"
        v-loading="loading"
        class="msg-table"
        :row-class-name="rowClassName"
        @row-click="onRowClick"
      >
        <el-table-column label="来源" width="120">
          <template #default="s">
            <el-tag size="small" :type="isRead(s.row) ? 'info' : 'warning'" :effect="isRead(s.row) ? 'plain' : 'light'">
              {{ sourceLabel(s.row.source) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="内容" min-width="280">
          <template #default="s">
            <span class="msg-body">
              <span v-if="!isRead(s.row)" class="unread-dot" aria-hidden="true"></span>
              {{ s.row.message }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="170">
          <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template #default="s">
            <el-tag v-if="isRead(s.row)" type="info" size="small" effect="plain">已读</el-tag>
            <el-tag v-else type="danger" size="small" effect="dark">未读</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > pageSize"
        class="pager"
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="onPage"
      />
    </div>
  </div>
</template>

<script>
import { fetchUserMessages, markMessagesRead, messageSourceLabel } from '@/utils/userHub'

export default {
  name: 'UserMessagesView',
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 20,
      readFilter: -1
    }
  },
  computed: {
    hasUnread() {
      return this.items.some((row) => !this.isRead(row))
    }
  },
  created() {
    this.load()
  },
  methods: {
    isRead(row) {
      return Number(row?.isRead) === 1
    },
    sourceLabel(source) {
      return messageSourceLabel(source)
    },
    rowClassName({ row }) {
      return this.isRead(row) ? 'msg-row-read' : 'msg-row-unread'
    },
    formatTime(ts) {
      if (!ts) return '—'
      if (typeof ts === 'string' && ts.includes('-')) return ts
      const n = Number(ts)
      if (!Number.isFinite(n) || n <= 0) return String(ts)
      if (n > 1e12) return new Date(n).toLocaleString()
      return new Date(n * 1000).toLocaleString()
    },
    async load() {
      this.loading = true
      try {
        const data = await fetchUserMessages({
          page: this.page,
          pageSize: this.pageSize,
          isRead: this.readFilter
        })
        this.items = data.items || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    onFilter() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    async onRowClick(row) {
      if (!row?.id || this.isRead(row)) return
      try {
        await markMessagesRead([row.id])
        const idx = this.items.indexOf(row)
        if (idx >= 0) {
          this.items.splice(idx, 1, { ...row, isRead: 1 })
        } else {
          row.isRead = 1
        }
      } catch (e) {
        this.$message.error(e.message || '标记已读失败')
      }
    },
    async markAllRead() {
      try {
        await markMessagesRead([])
        this.items = this.items.map((row) => ({ ...row, isRead: 1 }))
        this.$message.success('已全部标为已读')
        if (this.readFilter === 0) {
          this.load()
        }
      } catch (e) {
        this.$message.error(e.message || '标记已读失败')
      }
    }
  }
}
</script>

<style scoped>
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}
.page-head__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.site-page__title { margin: 0; }
.msg-hint { margin-bottom: 12px; font-size: 14px; }
.pager { margin-top: 16px; justify-content: center; }
.msg-body { display: inline-flex; align-items: center; gap: 8px; }
.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f56c6c;
  flex: 0 0 auto;
}
:deep(.msg-row-unread) {
  cursor: pointer;
  background: #fff6eb !important;
}
:deep(.msg-row-unread td.el-table__cell) {
  font-weight: 600;
  color: #303133;
  border-left: 3px solid #f56c6c;
}
:deep(.msg-row-unread td.el-table__cell:not(:first-child)) {
  border-left: none;
}
:deep(.msg-row-read td.el-table__cell) {
  color: #909399;
  font-weight: 400;
}
:deep(.msg-row-read .msg-body) {
  color: #909399;
}
</style>
